export default {
  equipment: {
    buildStations (factors) {
      const factorsFor = s => factors.filter((f, i) => { f.idx = i; return f.station === s }).sort((a, b) => a.part > b.part ? 1 : -1)
      return factors.map(f => f.station).filter((s, i, t) => t.indexOf(s) === i).sort().map(s => ({key: s, factors: factorsFor(s)}))
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/domain.js